import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all prioritys
export const getPriority = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/priority`);
    return response.data;
  } catch (error) {
    console.error("Error fetching prioritys:", error.response?.data || error);
    throw error;
  }
};

// GET a single priority
export const getPriorityById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/priority/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching priority:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new priority
export const createPriority = async (priorityData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/priority`, priorityData);
    return response.data;
  } catch (error) {
    console.error("Error creating priority:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing priority
export const updatePriority = async (id, priorityData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/priority/${id}`, priorityData);
    return response.data;
  } catch (error) {
    console.error("Error updating priority:", error.response?.data || error);
    throw error;
  }
};

// DELETE a priority
export const deletePriority = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/priority/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting priority:", error.response?.data || error);
    throw error;
  }
};
